// Unsubscribe — /baja?token=… · baja de los correos de campaña.
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MEDUSA_API_URL, MEDUSA_API_KEY } from '../services/medusa/config';
import SEO from '../components/SEO';
import './ForgotPassword.css';

export default function Unsubscribe() {
  const location = useLocation();
  const token = useMemo(() => new URLSearchParams(location.search).get('token') || '', [location.search]);
  const [state, setState] = useState('loading'); // loading | ok | error

  useEffect(() => {
    if (!token) { setState('error'); return; }
    fetch(`${MEDUSA_API_URL}/store/account-activation/unsubscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'x-publishable-api-key': MEDUSA_API_KEY },
      body: JSON.stringify({ token }),
    })
      .then((r) => setState(r.ok ? 'ok' : 'error'))
      .catch(() => setState('error'));
  }, [token]);

  return (
    <div className="forgot-page" data-header-theme="light">
      <SEO title="Preferencias de correo" description="Baja de correos Physiology." noindex />
      <div className="forgot-card">
        <div className="forgot-success">
          <p className="forgot-eyebrow">Preferencias de correo</p>
          <h1 className="forgot-success-headline">
            {state === 'loading' ? 'Un momento…' : state === 'ok' ? 'Listo, te dimos de baja.' : 'No pudimos procesar la baja.'}
          </h1>
          <p className="forgot-success-body">
            {state === 'ok'
              ? 'Ya no recibirás correos de promociones. Seguirás recibiendo los de tus pedidos.'
              : state === 'error'
              ? 'El enlace no es válido. Escríbenos a hello@physiologyskincare.com y lo resolvemos.'
              : ''}
          </p>
          <Link to="/" className="forgot-back">Volver al inicio</Link>
        </div>
      </div>
    </div>
  );
}
